import React from "react";
import { initials } from "../../data/contacts";
import myCardPhoto from "../../assets/images/my-card.webp";
import { ReactComponent as PersonIcon } from "../../assets/svgs/sf-symbols/phone/person.fill.svg";

// A contact's picture, as Phone and Messages show it: their photo (only My Card has one), their
// initials, or, for a number with no contact, a person.
const Avatar = ({ person, size = 51 }) => (
  <span className="ios-avatar" style={{ "--size": `${size}px` }} aria-hidden="true">
    {person && person.photo ? (
      <img src={myCardPhoto} alt="" draggable={false} />
    ) : person && person.first ? (
      initials(person)
    ) : (
      <PersonIcon className="ios-avatar-person" />
    )}
  </span>
);

export default Avatar;
